import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
import { DateRangeCalendar } from './DateRangeCalendar';
import { fees, photoshootStartTimes } from '../../data/units';
import { formatTime12 } from '../../utils/time';
interface PhotoshootSchedulerProps {
  date: string | null;
  startTime: string | null;
  endTime: string | null;
  onDateChange: (date: string | null) => void;
  onStartTimeChange: (time: string) => void;
}
export function PhotoshootScheduler({
  date,
  startTime,
  endTime,
  onDateChange,
  onStartTimeChange
}: PhotoshootSchedulerProps) {
  return <div className="space-y-8" data-id="element-127" data-mp="15fh93rjvgtyo">
      <DateRangeCalendar mode="single" start={date} onChange={start => onDateChange(start)} data-id="element-128" data-mp="15gsflz4pcfth" />

      <div data-id="element-129" data-mp="10hpkp7ifrpz8">
        <p className="text-[11px] uppercase tracking-overline text-gold-700" data-id="element-130" data-mp="10hz7km86ph0p">Start time</p>
        <div role="radiogroup" aria-label="Start time" className="mt-3 grid grid-cols-3 gap-2 sm:grid-cols-5" data-id="element-131" data-mp="2zqcu5tc8u1ic">
          {photoshootStartTimes.map(time => {
          const selected = time === startTime;
          return <button key={time} type="button" role="radio" aria-checked={selected} onClick={() => onStartTimeChange(time)} className={`rounded-full px-3 py-2.5 text-[13px] transition-colors duration-150 ease-premium active:scale-95 ${selected ? 'bg-forest-700 text-ivory-100' : 'bg-ivory-50 text-forest-700 ring-1 ring-forest-700/10 hover:bg-gold-100'}`} data-id="element-132" data-mp="3hvz4rtmr1tcf">
                {formatTime12(time)}
              </button>;
        })}
        </div>

        <AnimatePresence data-id="element-133" data-mp="3qvm3g7o3gl1s">
          {startTime && endTime && <motion.div initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-5 flex items-center gap-4 rounded-sm bg-forest-700 px-5 py-4 text-ivory-100" data-id="element-134" data-mp="3qtrl9147j71e">
              <ClockIcon size={18} className="shrink-0 text-gold-300" aria-hidden="true" data-id="element-135" data-mp="s3ol10m05m7b" />
              <span className="font-display text-lg" data-id="element-136" data-mp="o1thdpglmwqd">{formatTime12(startTime)}</span>
              <ArrowRightIcon size={15} className="text-gold-300" aria-hidden="true" data-id="element-137" data-mp="j3i93j5ycua9" />
              <span className="font-display text-lg" data-id="element-138" data-mp="e45bq4hgg4tf">{formatTime12(endTime)}</span>
              <span className="ml-auto text-[12px] text-ivory-200/70" data-id="element-139" data-mp="e68dflryzmdz">{fees.photoshootHours}-hour session</span>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}